export const NEWLY_CREATED_WORKFLOWS_IDS = 'newlyCreatedWorkflowsIds';